


























































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import API from '@/Api';
import { ICodeTable , IImageGalleryModel } from '@/models/Common';
import Api from '@/Api';
const namespace: string = 'AppStore';

@Component
export default class UploadImage extends Vue {
  public file: string = '""';
  public items: any = [];
  public fileName: string = '';
  public dialog: boolean = false;
  public dialog1: boolean = false;
  public datas: IImageGalleryModel[] = [];

    public headers: any = [
    {
      text: 'EventName',
      align: 'left',
      sortable: false,
      value: 'eventName',
    },
    {
      text: 'Image',
      align: 'left',
      sortable: false,
      value: 'image',
    },
    {
      text: 'Action',
      align: 'left',
      sortable: false,
    },
  ];


  public mounted() {
    this.loadData();
  }
  public getData() {
        API.Instance
        .get('/api/upload-image/getDetails')
        .then((respone) => {
          this.dialog = true;
          this.datas = respone.data;
        });
  }

  public handleFileUpload(event: any) {
    this.file = event.target.files;
    for (let i = this.file.length - 1; i >= 0; i--) {
      // console.log(this.file.length);
      const formData = new FormData();
      formData.append('file', this.file[i]);
      API.Instance.post('/api/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          this.$store.commit('AppStore/SNACK_BAR', {
            text: `File has been uploaded successfully!`,
            show: true,
          });
          this.items.url = response.data;
          this.dialog1 = true;
        })
        .catch(() => {
          this.$store.commit('AppStore/SNACK_BAR', {
            text: `Can't upload the given file, Please check the content!`,
            show: true,
          });
        });
    }
  }
  public uploadData() {
    API.Instance.post('/api/upload-image/uploadDetails', this.items)
      .then((res) => {
        this.loadData();
        this.dialog = false;
        this.$store.commit('AppStore/SNACK_BAR', {
          text: `Uploaded image and details successfully!`,
          show: true,
        });
      })
      .catch(() => {
        this.$store.commit('AppStore/SNACK_BAR', {
          text: `Can't upload the given file, Please check the content!`,
          show: true,
        });
      });
  }
  public loadData() {
    API.Instance.get('/api/upload-image').then((response) => {
      this.items = response.data;
    });
  }
  public deleteImage(item: any) {
    API.Instance
    .post('api/upload-image/deleteDetails?id=' + item.id)
    .then((res) => {
      this.loadData();
      this.getData();
    });
  }
}
